module.exports = __webpack_public_path__ + "img/LI.fb3eed41.svg";